import { useCallback, useRef } from "react";
import { useMediaQuery } from "@mui/material";

import { QUERIES } from "../../../utils/constants";

export const useDetailNavigation = () => {
  const isStacked = useMediaQuery(QUERIES.tabletLargeAndDown);
  const listRef = useRef<HTMLUListElement>(null);
  const detailRef = useRef<HTMLElement>(null);

  const openDetail = useCallback(() => {
    if (!isStacked) {
      return;
    }
    detailRef.current?.focus({ preventScroll: true });
    detailRef.current?.scrollIntoView({ block: "start" });
  }, [isStacked]);

  const backToList = () => {
    const selectedRow = listRef.current?.querySelector<HTMLButtonElement>(
      'button[aria-pressed="true"]',
    );
    selectedRow?.focus({ preventScroll: true });
    selectedRow?.scrollIntoView({ block: "center" });
  };

  return { isStacked, listRef, detailRef, openDetail, backToList };
};
